import React from "react";
import { FeatureCheck } from "./ui/feature-check";

export interface FeatureListProps {
  features: { feature: string; description: string }[];
}

export const FeatureList = ({ features }: FeatureListProps) => {
  if (features.length === 0) return null;

  return (
    <ul className="flex flex-col gap-2">
      {features.map((f, i) => (
        <li key={i} className="flex items-center gap-2">
          <FeatureCheck />
          {f.description ? (
            <div>
              <span className="font-medium text-text-primary">{f.feature}</span>{" "}
              <span className="text-text-secondary">{f.description}</span>
            </div>
          ) : (
            f.feature
          )}
        </li>
      ))}
    </ul>
  );
};
